import {LOGIN, LOGIN_FAILED, LOGIN_SUCCESS, LOGOUT} from "../actionTypes";
import fetch from "cross-fetch";
import {API_ROOT} from "../../config";
import {fetchBusiness} from "./business";

export function loginSuccess(key) {
  window.localStorage.setItem('authToken', key);
  return {
    type: LOGIN_SUCCESS,
    key: key,
  }
}

export function login({email, password}) {
  return dispatch => {
    dispatch(() => ({type: LOGIN}));
    return fetch(API_ROOT + '/rest-auth/login/', {
      method: 'POST',
      body: JSON.stringify({
        email,
        password
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      response.json().then(json => {
        dispatch(loginSuccess(json.key));
        dispatch(fetchBusiness());
      });
    }, error => {
      console.error(error);
      dispatch(() => ({type: LOGIN_FAILED}));
    })
  }
}

export function logout() {
  return dispatch => {
    window.localStorage.removeItem('authToken');
    return dispatch({type: LOGOUT});
  };
}


// WEBPACK FOOTER //
// ./src/state/actions/auth.js